<template>
  <div class="manage-question">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh sách câu hỏi của khách hàng</h6>
        </a-row>
      </template>
      <a-table
        :columns="columns"
        :loading="callingAPI"
        :data-source="dataSource"
        :pagination="pagination"
        @change="handleTableChangePage"
        rowKey="id"
      >
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {fetchQuestion} from '@/services/landing-page/home/customer-question'
  export default {
    name: 'ManageQuestion',
    data() {
      return {
        callingAPI: true,
        dataSource: [],
        columns: [
          {
            title: 'Email',
            dataIndex: 'email',
            scopedSlots: { customRender: 'title' },
            class: 'font-semibold',
          },
          {
            title: 'Phone',
            dataIndex: 'phone',
            class: 'font-semibold'
          },
          {
            title: 'Nội dung',
            dataIndex: 'content',
            scopedSlots: { customRender: 'content' },
          },
        ],

        pagination: {
          current: 1,
          total: 0,
          pageSize: 20
        }
      }
    },
    async beforeMount() {
      await this.loadData()
    },
    methods: {
      async loadData() {
        try {
          this.callingAPI = true
          const params = {
            page: this.pagination.current,
            per_page: this.pagination.pageSize
          }
          const response = await fetchQuestion(params)
          this.dataSource = response.data.data.map((d) =>({
            ...d,
            status: d.status === 1,
            loadingActive: false
          }))
          this.pagination.total = response.data.total
          this.callingAPI = false
        } catch (error) {
          
        }
      },

      async handleTableChangePage(pagination) {
        this.pagination.current = pagination.current;
        await this.loadData();
      },

      async handleChange(data) {
        await this.loadData(data.current)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>